import * as React from 'react';

import { IconPropsType } from 'designSystem/types/icons';

interface IZoomOutIconProps extends IconPropsType {}

const ZoomOutIcon = ({
  size = 20,
  fill = '#0D1536',
  stroke = '#5D5F66',
  strokeWidth = '1.08333',
  fillOpacity = '0.8',
  ...props
}: IZoomOutIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.72209 16.9442C13.7107 16.9442 16.9442 13.7107 16.9442 9.72209C16.9442 5.73344 13.7107 2.5 9.72209 2.5C5.73344 2.5 2.5 5.73344 2.5 9.72209C2.5 13.7107 5.73344 16.9442 9.72209 16.9442Z"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.75 18.7497L14.823 14.8227"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.01416 9.72211H12.4307"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ZoomOutIcon;
